module.exports = {
      id: "theme-icon-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#theme-icon",
      toString: function () {
        return this.url;
      }
    }